// Surface Charge Density units with conversion factors to coulomb per square meter (C/m²)
export const surfaceChargeDensityUnits = [
  { id: 'coulomb-per-square-meter', name: 'Coulomb per Square Meter', symbol: 'C/m²', plural: 'Coulombs per Square Meter', factor: 1 },
  { id: 'coulomb-per-square-centimeter', name: 'Coulomb per Square Centimeter', symbol: 'C/cm²', plural: 'Coulombs per Square Centimeter', factor: 10000 },
  { id: 'coulomb-per-square-inch', name: 'Coulomb per Square Inch', symbol: 'C/in²', plural: 'Coulombs per Square Inch', factor: 1550.0031 },
  { id: 'microcoulomb-per-square-meter', name: 'Microcoulomb per Square Meter', symbol: 'μC/m²', plural: 'Microcoulombs per Square Meter', factor: 1e-6 },
  { id: 'microcoulomb-per-square-centimeter', name: 'Microcoulomb per Square Centimeter', symbol: 'μC/cm²', plural: 'Microcoulombs per Square Centimeter', factor: 0.01 },
  { id: 'abcoulomb-per-square-meter', name: 'Abcoulomb per Square Meter', symbol: 'abC/m²', plural: 'Abcoulombs per Square Meter', factor: 10 },
  { id: 'abcoulomb-per-square-centimeter', name: 'Abcoulomb per Square Centimeter', symbol: 'abC/cm²', plural: 'Abcoulombs per Square Centimeter', factor: 100000 },
  { id: 'statcoulomb-per-square-meter', name: 'Statcoulomb per Square Meter', symbol: 'statC/m²', plural: 'Statcoulombs per Square Meter', factor: 3.335641e-10 },
  { id: 'statcoulomb-per-square-centimeter', name: 'Statcoulomb per Square Centimeter', symbol: 'statC/cm²', plural: 'Statcoulombs per Square Centimeter', factor: 3.335641e-6 },
];

export const popularSurfaceChargeDensityConversions = [
  { from: 'coulomb-per-square-meter', to: 'coulomb-per-square-centimeter' },
  { from: 'coulomb-per-square-centimeter', to: 'coulomb-per-square-meter' },
  { from: 'coulomb-per-square-meter', to: 'microcoulomb-per-square-meter' },
  { from: 'microcoulomb-per-square-meter', to: 'coulomb-per-square-meter' },
  { from: 'coulomb-per-square-meter', to: 'coulomb-per-square-inch' },
  { from: 'microcoulomb-per-square-centimeter', to: 'coulomb-per-square-centimeter' },
];

export const getUnitById = (id) => surfaceChargeDensityUnits.find(unit => unit.id === id);

export const convertSurfaceChargeDensity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert surface charge density units and learn the conversion formula.`;
};
